export const TEXTS = {
  ge: {
    home: "მთავარი",
    about: "ჩვენს შესახებ",
    contact: "დაგვიკავშირდი",
    ourService: "ჩვენი სერვისები",
    service: "სერვისები",
    prices: "ტარიფები",
    links: "ლინკები",
    contactInfo: "საკონტაქტო ინფორმაცია",
    geoTB: "საქართველო, თბილისი",
    geo: "ქართ.",
    eng: "ინგლ.",
    light: "დღე",
    dark: "ღამე",
    welcomeText: "მოგესალმებით BestSoft - ის ოჯახში!",
    customSeoKeywords: "ვებ გვერდების დამზადება, ვებ გვერდის დამზადება, ვებ საიტების დამზადება, ვებ საიტის დამზადება, როგორ დავამზადო ვებ გვერდი, სად დავამზადო ვებ საიტი, რა ღირს ვებ გვერდის დამზადება, რა ღირს ვებ საიტის დამზადება, ვებ დიზაინი, ui/ux დიზაინი, გრაფიკული დიზაინი, ლოგოს დამზადება, BestSoft, ბესთსოფთ, ბესთსოფთი, ბესთ სოფთი, პროფესიონალური ვებ-გვერდები, ხარისხიანი IT სერვისები, საუკეთესო ციფრული გადაწყვეტილებები",
    weTransform:
      "ჩვენ ვაქცევთ იდეებს ციფრულ რეალობად. BestSoft- ეს არის 4 საუკეთესო მეგობრისგან შექმნილი მჭიდრო გუნდი, რომელიც თქვენს ხედვას ციფრულ ხელოვნებად გარდაქმნის.  ჩვენთან ერთად თქვენი ციფრული წარმატება იწყება",
    webSites: "ვებ-გვერდების შექმნა",
    webSitesDescription:
      "ჩვენ გთავაზობთ სრული ციკლის ვებ დეველოპმენტს, რომელიც მოიცავს როგორც ფრონტ-ენდის, ასევე ბექ-ენდის დეველოპმენტს. ვქმნით თანამედროვე, რესპონსიულ და ინტერაქტიულ ვებ-გვერდებს, რომლებიც უზრუნველყოფენ მაღალ მომხმარებლის გამოცდილებასა და უსაფრთხოებას. ჩვენი სერვერის მხარის გადაწყვეტილებები უზრუნველყოფენ საიტის მასშტაბირებას და სანდო მუშაობას.",
    frontEnd: "ფრონტ-ენდ დეველოპმენტი",
    frontEndDescription:
      "შექმენით მოქნილი, ინტერაქტიული ინტერფეისები, რომლებიც უზრუნველყოფენ მომხმარებელთა კომფორტს.",
    appHelp: "აპლიკაციების მხარდაჭერა",
    backEnd: "ბექ-ენდ დეველოპმენტი",
    backEndDescription:
      "ძლიერი, მასშტაბური და უსაფრთხო სერვერის გადაწყვეტილებების შემუშავება თქვენი აპლიკაციების გასაძლიერებლად.",
    graphicDesign: "გრაფიკული დიზაინი",
    graphicDesignDescription:
      "თვალწარმტაცი გრაფიკისა და ვიზუალური შინაარსის შექმნა, რომელიც ტოვებს ხანგრძლივ შთაბეჭდილებას.",
    uiUxDesign: "UX/UI დიზაინი",
    uiUxDesignDescription:
      "ვიზუალურად მიმზიდველი, მოსახერხებელი ინტერფეისის შექმნა, რომელიც ასახავს თქვენი ბრენდის იდენტობას.",
    learnMore: "გაიგე მეტი",
    close: "დახურვა",
    aboutUs: "ჩვენს შესახებ",
    mission: "ჩვენი მისია და ხედვა",
    meetTeam: "გაიცანით ჩვენი გუნდი",
    aboutP1:
      "BestSoft დაიბადა ოთხი საუკეთესო მეგობრის: ნინო ბარჯაძის, ანი ბეროშვილის, თეონა ქართველიშვილისა და მარიამ ლავრელაშვილის საერთო ხედვიდან და გატაცებიდან. ჩვენ გვაქვს სხვადასხვა სფეროში გამოცდილება: ფრონტ-ენდ დეველოპმენტი, ბექ-ენდ დეველოპმენტი, გრაფიკულ დიზაინი და UX/UI დიზაინი. ეს უნიკალური უნარები და ცოდნა გავაერთიანეთ, რათა შეგვექმნა კომპანია, რომელიც უმაღლესი ხარისხის ციფრულ გადაწყვეტილებებს სთავაზობს მომხმარებლებს. ჩვენი ისტორია დაიწყო პატარა სახლში, სადაც გვიან ღამით ვატარებდით brainstorm-სესიებს და განვიხილავდით ტექნოლოგიისა და შემოქმედების ძალას.დღეს კი ვიქეცით სანდო პარტნიორად სხვადასხვა ზომის ბიზნესებისთვის, რათა მათ შეძლონ და წარმატებით გაუმკლავდნენ ციფრული სამყაროს გამოწვევებს.ჩვენთვის თითოეული პროექტი არის შესაძლებლობა, ვისწავლოთ, დავნერგოთ ინოვაცია და ვაჩვენოთ, რომ საზღვრები არ არსებობს. BestSoft-ის ღირებულებებია სრულყოფილება, ინოვაცია და პატიოსნება. ჩვენ მტკიცედ გვჯერა, რომ ყველა ბიზნესს, მიუხედავად მისი მასშტაბისა, უნდა ჰქონდეს ციფრული იდენტობა, რომელიც მისი უნიკალურობისა და ღირებულებების სრულად ასახვას უზრუნველყოფს.ამიტომ, ჩვენ განსაკუთრებულად ვუღრმავდებით კლიენტების სურვილებს, რათა მათი იდეები გადავაქციოთ შთამბეჭდავ ციფრულ გამოცდილებებად. ჩვენი გუნდი არ არის მხოლოდ თანამშრომლების ერთობა — ჩვენ ვართ ოჯახი, რომელიც გაერთიანებულია საერთო მისიის ირგვლივ: შევქმნათ და შთავაგონოთ.ჩვენთვის მთავარი პრიორიტეტია თანამშრომლობა. კლიენტებთან მჭიდრო მუშაობით ვცდილობთ, რომ ყველა პროექტმა არამარტო დააკმაყოფილოს, არამედ გადააჭარბოს მოლოდინებს. BestSoft არის არა უბრალოდ კომპანია, არამედ მტკიცებულება იმისა, თუ რამდენს მივაღწევთ, როცა გატაცება, მეგობრობა და პროფესიონალიზმი ერთიანდება.მზად ვართ შევხვდეთ მომავალს და გავაგრძელოთ ინოვაციების გზით სვლა, სადაც თითოეული პროექტი ახალი შესაძლებლობაა, კიდევ უფრო მაღალ მიზნებს მივაღწიოთ.",
    vision: `
      BestSoft-ში ჩვენ წარმოვიდგენთ სამყაროს, სადაც ტექნოლოგია და კრეატიულობა 
      ინტეგრირდება ისე, რომ იდეებს გარდაქმნის მნიშვნელოვან ციფრულ გამოცდილებად. 
      ჩვენი მიზანია ვიყოთ ინოვაციების წინა ხაზზე, ვქმნიდეთ გადაწყვეტილებებს, 
      რომლებიც არა მხოლოდ პასუხობენ დღევანდელ მოთხოვნებს, არამედ წინასწარ ჭვრეტენ 
      ხვალინდელ გამოწვევებს. ჩვენი ხედვაა, რომ გავაძლიეროთ ბიზნესები, რათა 
      მიაღწიონ მაქსიმალურ პოტენციალს ინოვაციური და ფუნქციონალური ციფრული 
      გადაწყვეტილებების მეშვეობით.
    `,
    mission2: `
      BestSoft-ის მისიაა ინოვაციური და მაღალი ხარისხის ციფრული გადაწყვეტილებების 
      მიწოდება, რომელიც დაეხმარება ბიზნესებს წარმატებას მიღწევაში მუდმივად 
      ცვალებად ციფრულ გარემოში. ჩვენ ვიაზრებთ ჩვენი კლიენტების ხედვებს რეალობად 
      უახლესი ტექნოლოგიების, კრეატიული დიზაინისა და სტრატეგიული ხედვის ერთობლიობის 
      მეშვეობით. ჩვენი ძირითადი პრინციპებია:
      1. სრულყოფილების მიწოდება: ჩვენ ვცდილობთ გადავაჭარბოთ მოლოდინებს, 
      ვაწარმოოთ გამორჩეული ნამუშევრები, რომლებიც აკმაყოფილებს უმაღლესი ხარისხისა 
      და ფუნქციონალურობის სტანდარტებს.
      2. ინოვაციების წახალისება: ჩვენ ვღებულობთ ახალ იდეებს და ტექნოლოგიებს, 
      ვცდილობთ მუდმივად გავაფართოვოთ საზღვრები, რათა შევქმნათ ინოვაციური გადაწყვეტილებები, 
      რომლებიც პროგრესს უწყობს ხელს.
      3. ძლიერი პარტნიორობის მშენებლობა: ჩვენ პრიორიტეტს ვანიჭებთ გრძელვადიანი 
      ურთიერთობების შექმნას კლიენტებთან გამჭვირვალობით, ნდობითა და მათი უნიკალური 
      საჭიროებების ღრმა გააზრებით.
      4. მომხმარებელთა გამოცდილების გაუმჯობესება: ჩვენ ვქმნით მომხმარებელზე 
      ორიენტირებულ ციფრულ პროდუქტებს, რომლებიც ვიზუალურად მიმზიდველი და 
      ფუნქციონალურია, რათა უზრუნველვყოთ ყველა მომხმარებლისთვის საუკეთესო 
      გამოცდილება.
      5. ზრდის წახალისება: ჩვენ ვუჭერთ მხარს ჩვენს კლიენტებს ზრდაში, 
      მათთვის მასშტაბირებადი და ადაპტირებადი გადაწყვეტილებების მიწოდებით, 
      რომლებიც შეძლებენ მათ ბიზნესთან ერთად განვითარებას.
      6. კრეატიული გარემოს გაძლიერება: ჩვენ ვაფასებთ კრეატიულობასა და თანამშრომლობას, 
      ვუწოდებთ ჩვენს გუნდს შემოიტანოს ახალი ხედვები და იდეები თითოეულ პროექტში.
      7. მდგრადობაზე ვალდებულება: ჩვენ ვართ ერთგული, რომ ჩავატაროთ მდგრადი 
      პრაქტიკები და შევქმნათ გადაწყვეტილებები, რომლებიც პოზიტიურ გავლენას მოახდენს 
      საზოგადოებაზე და გარემოზე.
    `,
    team: `
     BestSoft-ში ჩვენი ძალა ჩვენი ნიჭიერი და მრავალფეროვანი გუნდის გამორჩეულ შესაძლებლობებშია.
გაიცანი კრეატიული ადამიანები, რომლებიც შენს იდეებს ციფრულ რეალობად აქცევენ.
ჩვენი გუნდის თითოეული წევრი თავის სფეროში დახელოვნებული პროფესიონალია,
რომლებიც ერთად ქმნიან გამორჩეულ და ინოვაციურ ციფრულ გადაწყვეტილებებს.ჩვენი მიზანია არამხოლოდ მაღალი შედეგების მიღწევა, არამედ თქვენი წარმატების სრულფასოვანი უზრუნველყოფა და გამარტივება.
    `,
    teamMembers: {
      ani: "ანი არის გამოცდილი Full-stack Developer BestSoft-ში, რომელიც ქმნის ინტერაქტიულ და თანამედროვე ვებსაიტებს. ის სპეციალიზებულია HTML5, CSS3, JavaScript, React, Angular, Node.js, Express.js, და MongoDB-ში. ანი აქცევს დიზაინებს ფუნქციურ და მიმზიდველ ვებგვერდებად, რომლებიც სთავაზობს მომხმარებლებს საუკეთესო გამოცდილებას. ის მუდმივად იყენებს უახლეს Front-End ტექნოლოგიებს, რაც BestSoft-ის პროდუქტებს ინოვაციურს და თანამედროვე ხდის.",
      teo: "თეონა  არის პროფესიონალი ვებ-დეველოპერი, რომლის ტექნიკური უნარები მოიცავს HTML, CSS, JavaScript და React, Angular. მისი სიძლიერე Express.js, Node.js, C# და Python-ში აძლევს მას შესაძლებლობას შექმნას ძლიერი, უსაფრთხო და მასშტაბირებადი სერვერ-საიდუმლო გადაწყვეტილებები. აგრეთვე, ის ფლობს მონაცემთა ბაზებს, მათ შორის MongoDB, Microsoft SQL და PostgreSQL. მისი გამოცდილება UI/UX დიზაინსა და ეთიკურ ჰაკინგში აძლიერებს მომხმარებლის გამოცდილებას და უზრუნველყოფს ციფრული პროდუქტების უსაფრთხოებასა და შესრულებას. თეონას ინოვაციური მიდგომები და დეტალებზე ორიენტირებული მუშაობა მას საიმედო პარტნიორად აქცევს კომპლექსური პროექტების განხორციელებაში.",
      nino: "ნინო არის გრაფიკული და UX/UI დიზაინერი. იგი ქმნის როგორც გრაფიკულ, ისე მომხმარებელზე ორიენტირებულ ციფრულ გამოცდილებებს, რაც მოიცავს უნიკალურ ბრენდინგს, ლოგოებსა და UX/UI დიზაინს. მისი მიზანია შექმნას ვებსაიტები და აპლიკაციები, რომლებიც არა მხოლოდ ესთეტიკური იქნება, არამედ მარტივი და კომფორტული გამოსაყენებლად.",
      mari: "მარი არის გრაფიკული დიზაინერი, რომელიც მუშაობს ვიზუალური ხელოვნების სფეროში. იგი ქმნის ინოვაციურ ბრენდინგს, ლოგოებს, მარკეტინგულ მასალებსა და სოციალურ მედიის გრაფიკას. მისი მიზანია, ვიზუალურ იდენტობას მიანიჭოს ისეთი გამოსახულება, რომელიც ბრენდს უნიკალურობასა და ემოციურ კავშირებს მოუტანს.",
    },
    socialMediaLinks: "სოციალური ქსელები",
    names: {
      ani: "ანი ბეროშვილი",
      teo: "თეონა ქართველიშვილი",
      nino: "ნინო ბარჯაძე",
      mari: "მარიამ ლავრელაშვილი",
    },
    portfolio: "პორტფოლიო",
    introText:
      "აქ ვართ, რათა თქვენი ციფრული ხედვები რეალობად ვაქციოთ. თუ გაქვთ პროექტი, გჭირდებათ ტექნიკური მხარდაჭერა ან გსურთ მეტი გაიგოთ ჩვენი სერვისების შესახებ, გთხოვთ, ნუ მოგერიდებათ ჩვენთან დაკავშირება. მოუთმენლად გელით!",
    reachOut: "დაგვიკავშირდით",
    formLabels: {
      name: "სახელი",
      email: "ელ.ფოსტა",
      phone: "ტელეფონი",
      subject: "თემა",
      message: "შეტყობინება",
      submit: "გაგზავნა",
    },
    formPlaceholders: {
      name: "სახელი",
      email: "ელ.ფოსტა",
      phone: "ტელეფონი",
      subject: "მაგ. UX/UI დიზაინი",
      message: "შეტყობინება",
    },
    errors: {
      name: "სახელი აუცილებელია.",
      emailRequired: "ელ.ფოსტა აუცილებელია.",
      invalidEmail: "გთხოვთ, შეიყვანეთ ვალიდური ელ.ფოსტა.",
      phone: "ტელეფონი აუცილებელია.",
      subject: "თემა აუცილებელია.",
      message: "მესიჯი აუცილებელია.",
      invalidPhoneLength: "შეიყვანეთ სწორი საკონტაქტო ნომერი",
      selectedServices: "გთხოვთ აირჩიეთ სასურველი სერვისი",
    },
    submissionSuccess: "გაგზავნა წარმატებულია",
    contactInfoTitle: "ჩვენი საკონტაქტო ინფორმაცია",
    detailsTitle: "დეტალები",
    address: "მისამართი: BestSoft HQ 1234 თბილისი, საქართველო",
    phone: "ტელეფონი: ",
    email: "ელ.ფოსტა: ",
    workingHoursTitle: "სამუშაო საათები",
    workingHours: {
      weekdays: "ორშაბათი - პარასკევი: 9:00 AM - 6:00 PM",
      saturday: "შაბათი: 10:00 AM - 4:00 PM",
      sunday: "კვირა: დახურული",
    },
    connectWithUsTitle: "გახდი ჩვენი გუნდის ნაწილი ",
    connectWithUsText:
      "დარჩით ჩვენთან დაკავშირებული და იყავით მუდმივად ინფორმირებული BestSoft-ის სიახლეებზე, განახლებებსა და პროექტებზე. შემოგვიერთდით სოციალურ ქსელებში, იყავით ჩვენი საზოგადოების ნაწილი და ნახეთ, როგორ ვცვლით ციფრულ გამოცდილებას ყოველდღიურად.",
    services: {
      titleHeader: "გაეცანით ჩვენს სერვისებს",
      frontend: {
        title: "FRONT - END დეველოპმენტი",
        description: "ვებ-გვერდისა და აპლიკაციების წინა მხარის განვითარება",
        features: [
          "ვებსაიტების შექმნა HTML, CSS და JavaScript/Typescript-ის გამოყენებით",
          "სივი/პორტფოლიოს საიტები, ლენდინგ ფეიჯები, ბლოგები და ბიზნესის ვებსაიტები",
          "რეაქტიული (Responsive) დიზაინი, რომელიც ყველა მოწყობილობაზე კარგად გამოიყურება",
          "ვებ-ანიმაციები და ინტერაქტიული ელემენტები",
          "ტექნოლოგიები და ხელსაწყოები (React, Angular, Next.js)",
          "კროს-ბრაუზერული თავსებადობა",
        ],
        uxui: {
          title: "UX/UI ინტეგრაცია",
          features: [
            "UX/UI დიზაინის იმპლემენტაცია და ოპტიმიზაცია",
            "ქსელის ოპტიმიზაცია და გვერდების ჩატვირთვის სისწრაფის გაუმჯობესება",
            "ინტერაქტიული კომპონენტების დამატება, როგორიცაა ნავიგაცია, ფორმები, ღილაკები და სხვა ელემენტები",
          ],
        },
        optimization: {
          title: "ვებსაიტების ოპტიმიზაცია",
          features: [
            "SEO ოპტიმიზაცია, რათა საიტი საძიებო სისტემებში მაღალ პოზიციაზე იყოს",
            "პროგრესული ვებ აპლიკაციების (PWA) განვითარება",
          ],
        },
        support: {
          title: "მუდმივი მხარდაჭერა და განახლება",
          features: [
            "ვებსაიტის ტექნიკური მხარდაჭერა და რეგულარული განახლებები",
            "ახალი ფუნქციების დამატება, როგორიცაა ფორუმი, გალერეა, სოციალური მედიის ინტეგრაცია და სხვა",
            "საიტის რეგულარული ტესტირება და გაუმჯობესება",
          ],
        },
      },
      backend: {
        title: "BACK - END დეველოპმენტი",
        description: "სერვერის მხარის განვითარება და მენეჯმენტი",
        features: [
          "ვებ აპლიკაციების სერვერის მხარის განვითარება",
          "ფორუმი, ბლოგი, კომუნიკაციის სისტემები და ჩეთები",
          "გადახდის სისტემები, სერვერის არქიტექტურა და API-ების შემუშავება",
          "მონაცემთა ბაზის დიზაინი და მართვა (SQL და NoSQL)",
          "უსაფრთხოების მექანიზმების იმპლემენტაცია",
        ],
        integration: {
          title: "ინტეგრაცია და მასშტაბურობა",
          features: [
            "მონაცემთა მასშტაბირებადი სისტემების შექმნა",
            "ქლაუდ სერვისების ინტეგრაცია",
            "რეალურ დროში მონაცემების მართვა",
          ],
        },
        security: {
          title: "უსაფრთხოება და შესრულება",
          features: [
            "სერვერის უსაფრთხოების გაუმჯობესება",
            "სერვერის პერფორმანსის ოპტიმიზაცია",
            "ხარვეზების აღმოფხვრა და სისტემის გაუმჯობესება",
          ],
        },
        support: {
          title: "მუდმივი მხარდაჭერა და ტექნიკური მომსახურება",
          features: [
            "სერვერის და მონაცემთა ბაზის მუდმივი ტექნიკური მხარდაჭერა",
            "ახალი ფუნქციების დამატება და სისტემის განახლება",
            "სერვერის რეგულარული მონიტორინგი და გაუმჯობესება",
          ],
        },
      },
      design: {
        title: "გრაფიკული დიზაინი",
        branding: {
          title: "ლოგოსა და ბრენდის იდენტობის დიზაინი",
          features: [
            "ლოგოს შექმნა",
            "სრული ბრენდ-იდენტობის პაკეტი",
            "სავიზიტო ბარათები",
            "სოციალური მედიის ბრენდინგი",
          ],
        },
        print: {
          title: "ბეჭდვითი დიზაინი",
          features: [
            "ბროშურები, ფლაერები და პოსტერი",
            "პროდუქტის შეფუთვის დიზაინი",
            "ღონისძიების მასალები",
            "პროდუქციის დიზაინი",
          ],
        },
        marketing: {
          title: "მარკეტინგის მასალები",
          features: [
            "გაყიდვების პრეზენტაციები და პიჩ-დეკები",
            "კორპორაციული ბროშურები",
            "სარეკლამო პოსტერები და ბანერები",
          ],
        },
        illustration: {
          title: "ილუსტრაციები",
          features: [
            "ილუსტრაციები რედაქტორისთვის",
            "პერსონალური ილუსტრაციები",
            "წიგნის ილუსტრაციები",
          ],
        },
      },
      uxui: {
        title: "UX/UI დიზაინი",
        ux: {
          title: "UX დიზაინი",
          features: [
            "მომხმარებლის კვლევა",
            "ინფორმაციის არქიტექტურა",
            "ვაირფრემები და პროტოტიპები",
            "მომხმარებლის ტესტირება",
            "ინტერაქციული დიზაინი",
          ],
        },
        ui: {
          title: "UI დიზაინი",
          features: [
            "ვიზუალური დიზაინი",
            "რესფონსიული დიზაინი",
            "დიზაინის სისტემები",
            "მაღალი ხარისხის მოქაფები",
          ],
        },
        website: {
          title: "ვებსაიტისა და აპლიკაციის დიზაინი",
          features: [
            "ლენდინგ გვერდები",
            "ეკომერსის გვერდები",
            "მობილური აპლიკაციის ინტერფეისი",
          ],
        },
        optimization: {
          title: "განახლება და ოპტიმიზაცია",
          features: [
            "UX აუდიტები",
            "მომხმარებლისთვის მორგებული განახლებები",
            "A/B ტესტირება",
          ],
        },
      },
      priceButton: "გამოითვალე ფასი",
    },
    calculationTitle: "ტარიფის კალკულაცია",
    categories: {
      design: "დიზაინი",
      graphicDesign: "გრაფიკული დიზაინი",
      webDesign: "ვებ დიზაინი",
      development: "დეველოპმენტი",
      frontEndDevelopment: "Front-End დეველოპმენტი",
      backEndDevelopment: "Back-End დეველოპმენტი",
    },
    services2: {
      logoCreation: "ლოგოს შექმნა",
      brandIdentityPackage: "ბრენდ-იდენტობის პაკეტი",
      socialMediaBranding: "სოციალური მედიის ბრენდინგი",
      illustrations: "ილუსტრაციები",
      landingPage: "ლენდინგ გვერდი",
      cvPortfolioSite: "CV/პორტფოლიო საიტი",
      blogSite: "ბლოგის საიტი",
      blogSiteUpTo5Pages: "5 გვერდამდე ბლოგის ტიპის საიტი",
      functionalSite5PlusPages: "5+ გვერდი ფუნქციური საიტი",
      eCommerceSite: "E-commerce ტიპის საიტი",
      languageTranslation: "ენის თარგმნა",
      themeChange: "თემის ცვლილება",
      registrationAuthorization: "რეგისტრაცია/ავტორიზაცია",
      adminPanel: "ადმინ პანელი",
    },
    formLabel: {
      email: "ელ. ფოსტა",
      phone: "ტელეფონი",
      additionalMessage: "დამატებითი შეტყობინება",
      submit: "გაგზავნა",
    },
    placeholder: {
      selectedServices: "მონიშნული სერვისები...",
      email: "abc@gmail.com",
      phone: "555 55 55 55",
      additionalMessage: "დამატებითი მოთხოვნები",
    },
    pricesTitle: "ფასები - BestSoft-ის სერვისების ფასები",
    pricesDescription:
      "გაიგეთ ჩვენი პროგრამული უზრუნველყოფის სერვისების ფასები და მიიღეთ საუკეთესო შეთავაზებები თქვენი ბიზნესისთვის.",
    pricesKeywords:
      "ფასები, BestSoft, ბესთსოფთ, ბესთსოფთი ბესთ სოფთი, სერვისების ფასები, შეთავაზებები, პროგრამული უზრუნველყოფა, რა ღირს ვებ გვერდის დამზადება, რა ღირს ვებ საიტის დამზადება, ვებ დიზაინის ფასი, ui/ux დიზაინის ფასი, გრაფიკული დიზაინის ფასი, ლოგოს დამზადების ფასი",
    servicesTitle: "ჩვენი სერვისები - BestSoft",
    servicesDescription:
      "შეისწავლეთ ჩვენი მრავალფეროვანი პროგრამული უზრუნველყოფის სერვისები, მათ შორის ვებ, მობილური და გრაფიკული დიზაინი.",
    servicesKeywords:
      "სერვისები,ბესთსოფთ, ბესთსოფთი, ბესთ სოფთი, პროგრამული უზრუნველყოფა, ვებ დეველოპმენტი, მობილური აპლიკაციები, გრაფიკული დიზაინი, ვებ გვერდების დამზადება, ვებ საიტების დამზადება, ვებ დიზაინი, ui/ux დიზაინი, ლოგოს დამზადება, როგორ დავამზადო ვებ გვერდი, რა ღირს ვებ გვერდის დამზადება",
    contactTitle: "დაგვიკავშირდით - BestSoft-ის გუნდთან კონტაქტი",
    contactDescription:
      "დაგვიკავშირდით BestSoft-ის გუნდს ნებისმიერი შეკითხვის ან დახმარებისათვის. ჩვენ ყოველთვის მზად ვართ დაგეხმაროთ.",
    contactKeywords:
      "კონტაქტი, BestSoft,ბესთსოფთ, ბესთსოფთი, ბესთ სოფთი, დაგვიკავშირდით, დახმარება, კონსულტაცია, ვებ გვერდების დამზადება, ვებ საიტის დამზადება, სად დავამზადო ვებ საიტი, რა ღირს ვებ გვერდის დამზადება, ვებ დიზაინი, ui/ux დიზაინი, გრაფიკული დიზაინი, ლოგოს დამზადება",

    aboutTitle: "BestSoft - ჩვენს შესახებ",
    aboutDescription:
      "გაიგეთ მეტი BestSoft-ის შესახებ, ჩვენი მისია, ღირებულებები და როგორ ვეხმარებით ბიზნესებს განვითარებაში ინოვაციური პროგრამული გადაწყვეტილებებით.",
    aboutKeywords:
      "ჩვენს შესახებ, BestSoft,ბესთსოფთ, ბესთსოფთი, ბესთ სოფთი, პროგრამული უზრუნველყოფა, მისია, კომპანია",
    projects: "ჩვენი პროექტები",
    description: "აღწერა",
    technologies: "ტექნოლოგიები",
    showDetails: "დეტალები",
    hideDetails: "დახურვა",
    portfolioTitle: "პორტფოლიო - BestSoft-ის პროექტები",
    portfolioDescription:
      "ნახეთ BestSoft-ის განხორციელებული პროექტები და სამუშაოს ნიმუშები.",
    portfolioKeywords:
      "პორტფოლიო, პროექტები, BestSoft, ბესთსოფთ, ბესთსოფთი, ბესთ სოფთი, ვებ დეველოპმენტი, მობილური აპლიკაციები",
    projectDescriptions: [
      "E-commerce პლატფორმა  ადმინ პანელით, რომელიც მოიცავს კატეგორიების, ფერების, ზომების და ატრიბუტების მართვას, CRUD ოპერაციებს, პროდუქტების დამატებას, მომხმარებლების,  შეკვეთების და ბანერების მენეჯმენტს",
      "ხელნაკეთი ნივთებისთვის ლენდინგ გვერდი ელეგანტური დიზაინით",
      "E-commerce პლატფორმა მხატვრებისთვის და მომხმარებლებისთვის, ადმინ პანელით",
      "საბავშვო გართობის ცენტრის პლატფორმა დაბადების დღეებისა და ღონისძიებების დაჯავშნისთვის, ონლაინ რეზერვაციებითა და წვეულების პაკეტების არჩევით",
      "E-commerce პლატფორმა გამყიდველებისა და მომხმარებლებისთვის, ადმინ პანელით",
      "პირველი ქართული შესყიდვების პლატფორმა",
      "კრეატიული ფოტო სტუდიის ვებსაიტი",
      "აპლიკაცია განკუთვნილია ხარჯების მართვისა და ორგანიზებისთვის, მოიცავს სრულ CRUD ოპერაციებს და ადმინის პანელს ავთენტიფიკაციით. იყენებს Express.js ბექენდისთვის და React.js ფრონტენდისთვის.",
      "პლატფორმა მატარებლის ბილეთების ონლაინ დაჯავშნისა და შესყიდვისთვის",
      "პროგრამული უზრუნველყოფის შემქმნელი კომპანიის ვებგვერდი, რომელიც წარმოაჩენს სერვისებსა და პროექტებს React-ის გამოყენებით",
      "კრეატიული დიზაინ სტუდიის ვებსაიტი",
      "დავალებაზე დაფუძნებული პროექტი Tbc Academy-სთვის, რომელიც მოიცავს კარუსელებს, აგებულს JavaScript, HTML და CSS-ის გამოყენებით",
      "React-ზე დაფუძნებული პროექტი, რომელიც მოიცავს ადგილობრივ მეხსიერებას და ფორმების დამუშავებას Redberry Knight Cup-ში გუნდების მენეჯმენტისთვის",
      "კრეატიული დიზაინ სტუდიის ვებსაიტი",
      "რესპონსიული ტექნოლოგიური ლენდინგ გვერდი, რომელიც წარმოაჩენს თანამედროვე დიზაინის ელემენტებს, მათ შორის გლუვ ანიმაციებსა და ინტერაქტიულ კომპონენტებს",
      "მარტივი ვებ აპლიკაცია, რომელიც იღებს და აჩვენებს შემთხვევით რჩევებს, აგებული სუფთა JavaScript-ის გამოყენებით და სტილიზებული CSS-ით",
      "საინტერესო ფერის გამოცნობის თამაში, რომელიც მოთამაშეებს სთავაზობს გამოიცნონ სწორი ფერის კოდი, აგებული ვანილა JavaScript-ით",
      "ჩაის კალკულატორის აპლიკაცია, რომელიც მომხმარებლებს ეხმარება გამოთვალოს ჩაი ანგარიშის თანხისა და არჩეული ჩაის პროცენტის მიხედვით",
      "ძირითადი ონლაინ მაღაზიის გვერდი ინტერაქტიული ფუნქციებით, აგებული ვანილა JavaScript, HTML და CSS-ის გამოყენებით",
      "E-Learning პლატფორმის ლამაზი და რესპონსიული ლენდინგ გვერდი, რომელიც წარმოაჩენს თანამედროვე დიზაინსა და გლუვ გადასვლებს",
      "მარტივი და ფუნქციონალური კალკულატორის აპლიკაცია, აგებული ვანილა JavaScript-ის გამოყენებით საგანმანათლებლო მიზნებისთვის",
      "საბავშვო ბაღისთვის შექმნილი მხიარული და ფერადი გვერდი, რომელიც მოიცავს დინამიურ ელემენტებსა და გლუვ ანიმაციებს",
    ],
  },

  en: {
    home: "HOME",
    about: "ABOUT US",
    contact: "CONTACT US",
    ourService: "OUR SERVICE",
    service: "SERVICES",
    prices: "PRICES",
    links: "Links",
    contactInfo: "Contact Information",
    geoTB: "Georgia, Tbilisi",
    geo: "GEO",
    eng: "ENG",
    light: "LIGHT",
    dark: "DARK",
    welcomeText: "Welcome to the BestSoft family!",
    customSeoKeywords: "web page development, web page creation, website development, website creation, how to create a web page, where to create a website, how much does web page development cost, how much does website development cost, web design, ui/ux design, graphic design, logo creation, BestSoft, professional web development, high-quality IT services, best digital solutions",
    weTransform:
      "We transform ideas into digital realities. As a close-knit team of four best friends, we are passionate about bringing your vision to life with our comprehensive suite of services.",
    webSites: "Website Development",
    webSitesDescription:
      "We offer full-cycle web development that includes both front-end and back-end development. We create modern, responsive, and interactive websites that ensure excellent user experience and security. Our server-side solutions guarantee scalability and reliable performance for your website.",
    frontEnd: "Front-End Development",
    frontEndDescription:
      "Building responsive, interactive interfaces that provide an excellent user experience.",
    appHelp: "Application Support",
    backEnd: "Back-End Development",
    backEndDescription:
      "Developing robust, scalable, and secure server-side solutions to power your applications.",
    graphicDesign: "Graphic Design",
    graphicDesignDescription:
      "Creating eye-catching graphics and visual content that leave a lasting impression.",
    uiUxDesign: "UX/UI Design",
    uiUxDesignDescription:
      "Crafting visually appealing, user-friendly interfaces that reflect your brand identity.",
    learnMore: "Learn more",
    close: "close",
    aboutUs: "About Us",
    mission: "Our Mission and Vision",
    meetTeam: "Meet Our Team",
    aboutP1:
      "BestSoft was born out of the shared vision and passion of four best friends: Nino Barjadze, Ani Beroshvili, Teona Kartvelishvili, and Mariam Lavrelashvili. With diverse backgrounds in front-end development, back-end development, graphic design, and UX/UI design, we combined our unique skills and expertise to create a company dedicated to delivering top-notch digital solutions. From our humble beginnings, we've grown into a trusted partner for businesses of all sizes, helping them to navigate the ever-evolving digital landscape. Our journey started in a small home office, fueled by late-night brainstorming sessions and an unwavering belief in the power of technology and creativity. Each project has been a new opportunity  to learn, innovate, and push the boundaries of what's possible in  web design and development. At the core of BestSoft is our  commitment to excellence, innovation, and integrity. We believe that  every business, no matter how big or small, deserves a digital  presence that reflects its unique identity and values. That's why we  take the time to understand our clients' visions and transform them  into impactful digital experiences. Our team is more than just a  group of colleagues; we're a family united by a shared mission to  create and inspire. We pride ourselves on our collaborative  approach, working closely with our clients to ensure that every   project not only meets but exceeds their expectations. BestSoft is  not just a company; it's a testament to what can be achieved when   passion, friendship, and expertise come together. We are excited   about the future and look forward to continuing our journey, one  innovative solution at a time. ",
    vision: `
      At BestSoft, we envision a world where technology and creativity seamlessly integrate 
      to transform ideas into impactful digital experiences. We strive to be at the forefront 
      of innovation, crafting solutions that not only meet the needs of today but anticipate 
      the challenges of tomorrow. Our vision is to empower businesses to achieve their full 
      potential through cutting-edge digital solutions that are as functional as they are beautiful.
    `,
    mission2: `
      At BestSoft, our mission is to deliver innovative and high-quality digital solutions 
      that empower businesses to succeed in an ever-evolving digital landscape. We are dedicated 
      to transforming our clients' visions into reality through a blend of cutting-edge technology, 
      creative design, and strategic insight. Our core principles guide us to:
      1. Deliver Excellence: We strive to exceed expectations by producing exceptional work that 
      meets the highest standards of quality and functionality.
      2. Foster Innovation: We embrace new ideas and technologies, constantly pushing the boundaries 
      to create innovative solutions that drive progress.
      3. Build Strong Partnerships: We prioritize building lasting relationships with our clients 
      through transparency, trust, and a deep understanding of their unique needs.
      4. Enhance User Experiences: We are committed to designing user-centric digital products that 
      are both visually appealing and highly functional, ensuring an optimal experience for all users.
      5. Promote Growth: We support our clients' growth by providing scalable and adaptable solutions 
      that can evolve with their business.
      6. Cultivate a Creative Environment: We foster a culture of creativity and collaboration, 
      encouraging our team to bring fresh perspectives and ideas to every project.
      7. Commit to Sustainability: We are dedicated to implementing sustainable practices and creating 
      solutions that have a positive impact on society and the environment.
    `,
    team: `
      At BestSoft, our strength lies in our talented and diverse team. Meet the creative minds 
      who bring your visions to life. Each member of our team is a specialist in their field, 
      working together to deliver exceptional digital solutions. We are passionate about what 
      we do, and we are here to help you succeed.
    `,
    teamMembers: {
      ani: "Ani Beroshvili is a skilled Front-End Developer at BestSoft, known for her passion for creating responsive and interactive user interfaces. With expertise in HTML5, CSS3, JavaScript,node.js, mongoDB and frameworks such as React, Angular, Next.js and express.js, Ani brings web designs to life with precision and creativity. She is dedicated to ensuring that every website is both visually appealing and highly functional, providing users with an exceptional browsing experience. Ani's commitment to staying updated with the latest front-end technologies ensures that BestSoft's solutions are always cutting-edge.",
      teo: "Teona Kartvelishvili is a professional web developer with expertise in HTML, CSS, JavaScript, React and Angular. Her strength Express.js, Node.js, C# and Python enables her to build robust, secure, and scalable back-end solutions. She is also proficient in databases, including MongoDB, Microsoft SQL, and PostgreSQL.Her experience in UI/UX design and ethical hacking enhances the user experience and ensures security and performance in digital products. Teona's innovative approach and attention to detail make her a reliable partner for executing complex projects.",
      nino: "Nino is a graphic and UX/UI designer who has been working in both graphic design and user-centered digital experiences. She creates unique branding, logos, and responsive UX/UI designs. Her aim is to design websites and applications that are not only visually appealing but also simple and intuitive to use.",
      mari: "Mari is a graphic designer who has been working in the field of visual arts, creating innovative branding, logos, marketing materials, and social media graphics. Her aim is to develop a visual identity that gives a unique and emotional connection to your brand.",
    },
    socialMediaLinks: "Social Media Links ",
    names: {
      ani: "Ani Beroshvili",
      teo: "Teona Kartvelishvili",
      nino: "Nino Barjadze",
      mari: " Mariam Lavrelashvili",
    },
    portfolio: "PORTFOLIO",

    introText:
      "We're here to help you bring your digital visions to life. Whether you have a project in mind, need technical support, or just want to learn more about our services, feel free to reach out to us. We look forward to hearing from you!",
    reachOut: "Reach Out to Us",
    formLabels: {
      name: "Name",
      email: "Email",
      phone: "Phone Number",
      subject: "Subject",
      message: "Message",
      submit: "Submit",
    },
    formPlaceholders: {
      name: "Name",
      email: "E-mail",
      phone: "Phone Number",
      subject: "E.g. UX/UI Design",
      message: "Text Area",
    },
    errors: {
      name: "Name is required.",
      emailRequired: "Email is required.",
      invalidEmail: "Please enter a valid email address.",
      phone: "Phone number is required.",
      subject: "Subject is required.",
      message: "Message is required.",
      invalidPhoneLength: "Invalid Phone Number",
      selectedServices: "please select service",
    },
    submissionSuccess: "Submission Successful",
    contactInfoTitle: "Our Contact Information",
    detailsTitle: "Details",
    address: "Address: BestSoft HQ 1234 Tbilisi, Georgia",
    phone: "Phone: ",
    email: "Email: ",
    workingHoursTitle: "Working Hours",
    workingHours: {
      weekdays: "Monday - Friday: 9:00 AM - 6:00 PM",
      saturday: "Saturday: 10:00 AM - 4:00 PM",
      sunday: "Sunday: Closed",
    },
    connectWithUsTitle: "Connect with Us",
    connectWithUsText:
      "Stay connected and keep up to date with the latest news, updates, and projects from BestSoft. Follow us on social media to join our community and see how we're transforming digital experiences every day.",

    services: {
      titleHeader: "Explore Our Services",
      frontend: {
        title: "FRONT-END Development",
        description:
          "Development of the front side of websites and applications",
        features: [
          "Creating websites using HTML, CSS, and JavaScript/Typescript",
          "CV/portfolio sites, landing pages, blogs, and business websites",
          "Responsive design that looks good on all devices",
          "Web animations and interactive elements",
          "Technologies and tools (React, Angular, Next.js)",
          "Cross-browser compatibility",
        ],
        uxui: {
          title: "UX/UI Integration",
          features: [
            "Implementation and optimization of UX/UI design",
            "Network optimization and page load speed improvement",
            "Adding interactive components like navigation, forms, buttons, and more",
          ],
        },
        optimization: {
          title: "Website Optimization",
          features: [
            "SEO optimization to rank high on search engines",
            "Progressive web applications (PWA) development",
          ],
        },
        support: {
          title: "Ongoing Support and Updates",
          features: [
            "Technical support and regular updates",
            "Adding new features like forums, galleries, social media integration, and more",
            "Regular site testing and improvements",
          ],
        },
      },
      backend: {
        title: "BACK-END Development",
        description: "Development and management of the server side",
        features: [
          "Development of the server side of web applications",
          "Forums, blogs, communication systems, and chats",
          "Payment systems for purchasing products",
          "Server architecture design and API development",
          "Database design and management (SQL and NoSQL)",
          "Implementation of security mechanisms to protect user data",
        ],
        integration: {
          title: "Integration and Scalability",
          features: [
            "Creating scalable systems to handle large user traffic",
            "Cloud service integration (AWS, Google Cloud, Azure) for reliability and speed",
            "Real-time data management (WebSockets, chats, notifications)",
          ],
        },
        security: {
          title: "Security and Performance",
          features: [
            "Enhancing server security",
            "Optimizing server performance",
            "Bug fixes and system improvements",
          ],
        },
        support: {
          title: "Ongoing Support and Maintenance",
          features: [
            "Technical support for servers and databases",
            "Regular updates and adding new features",
            "Server monitoring and improvement",
          ],
        },
      },
      design: {
        title: "Graphic Design",
        branding: {
          title: "Logo and Brand Identity Design",
          features: [
            "Logo creation",
            "Full brand identity package",
            "Business cards",
            "Social media branding",
          ],
        },
        print: {
          title: "Print Design",
          features: [
            "Brochures, flyers, and posters",
            "Product packaging design",
            "Event materials",
            "Merchandise design",
          ],
        },
        marketing: {
          title: "Marketing Materials",
          features: [
            "Sales presentations and pitch decks",
            "Corporate brochures",
            "Ad posters and banners",
          ],
        },
        illustration: {
          title: "Illustrations",
          features: [
            "Editorial illustrations",
            "Personalized illustrations",
            "Book illustrations",
          ],
        },
      },
      uxui: {
        title: "UX/UI Design",
        ux: {
          title: "UX Design",
          features: [
            "User research",
            "Information architecture",
            "Wireframes and prototypes",
            "User testing",
            "Interactive design",
          ],
        },
        ui: {
          title: "UI Design",
          features: [
            "Visual design",
            "Responsive design",
            "Design systems",
            "High-fidelity mockups",
          ],
        },
        website: {
          title: "Website & App Design",
          features: [
            "Landing pages",
            "E-commerce sites",
            "Mobile app interfaces",
          ],
        },
        optimization: {
          title: "Optimization & Updates",
          features: ["UX audits", "User-centered updates", "A/B testing"],
        },
      },
      priceButton: "Calculate Price",
    },

    calculationTitle: "Price Calculation",

    categories: {
      design: "Design",
      graphicDesign: "Graphic Design",
      webDesign: "Web Design",
      development: "Development",
      frontEndDevelopment: "Front-End Development",
      backEndDevelopment: "Back-End Development",
    },
    services2: {
      logoCreation: "Logo Creation",
      brandIdentityPackage: "Brand Identity Package",
      socialMediaBranding: "Social Media Branding",
      illustrations: "Illustrations",
      landingPage: "Landing Page",
      cvPortfolioSite: "CV/Portfolio Site",
      blogSite: "Blog Site",
      blogSiteUpTo5Pages: "Up to 5 Pages Blog Type Site",
      functionalSite5PlusPages: "Functional Site 5+ Pages",
      eCommerceSite: "E-commerce Type Site",
      languageTranslation: "Language Translation",
      themeChange: "Theme Change",
      registrationAuthorization: "Registration/Authorization",
      adminPanel: "Admin Panel",
    },
    formLabel: {
      email: "Email",
      phone: "Phone",
      additionalMessage: "Additional Message",
      submit: "Submit",
    },
    placeholder: {
      selectedServices: "Selected Services...",
      email: "abc@gmail.com",
      phone: "555 55 55 55",
      additionalMessage: "Additional Requirements",
    },

    pricesTitle: "Prices - BestSoft Service Pricing",
    pricesDescription:
      "Discover the pricing for our software development services and get the best offers for your business.",
    pricesKeywords:
      "prices, BestSoft, service pricing, offers, software development, how much does web development cost, website development cost, web design pricing, ui/ux design pricing, graphic design pricing, logo creation cost",
    servicesTitle: "Our Services - BestSoft",
    servicesDescription:
      "Explore our wide range of software development services, including web, mobile, and graphic design.",
    servicesKeywords:
      "services, software development, web design, mobile apps, graphic design, web page development, website development, ui/ux design, logo creation, how to create a web page, how much does web development cost",
    contactTitle: "Contact - Get in touch with BestSoft's team",
    contactDescription:
      "Contact BestSoft's team for any inquiries or support. We're always ready to assist with your needs.",
    contactKeywords: "contact, BestSoft, get in touch, support, consultation, web page development, website creation, where to create a website, how much does web development cost, web design, ui/ux design, graphic design, logo creation",

    aboutTitle: "About BestSoft - Learn More About Us",
    aboutDescription:
      "Learn more about BestSoft, our mission, values, and how we help businesses grow through innovative software solutions.",
    aboutKeywords: "about us, BestSoft, software solutions, company, mission",
    projects: "Our Projects",
    description: "Description",
    technologies: "Technologies",
    showDetails: "Show Details",
    hideDetails: "Hide Details",
    portfolioTitle: "Portfolio - BestSoft's Projects",
    portfolioDescription:
      "Explore our portfolio of completed projects and work samples at BestSoft.",
    portfolioKeywords:
      "portfolio, projects, BestSoft, web development, mobile apps, samples, work",
  },
};
